import React from 'react';
import {
  Image, StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';

const SideMenuItem = ({ categoryObject, onPress, selected }) => {
  const myStyles = StyleSheet.create({
    frameCircle: {
      borderRadius: 5,
      border: selected ? 'solid 2px #008cff' : 'solid 2px #edf2f7',
      padding: 5,
      backgroundColor: !selected && '#f7fafc',
      width: 45,
      height: 45,
      alignSelf: 'center',
    },
    tabImageStyle: {
      height: '100%',
      width: '100%',
    },
    tabLabelStyle: {
      fontFamily: 'Rubik-Regular',
      fontSize: 10,
      color: '#718096',
      alignSelf: 'center',
      marginTop: 3,
      marginBottom: 15,
    },
  });
  return (
    <TouchableOpacity
      onPress={onPress}
    >
      <View style={myStyles.frameCircle}>
        <Image
          fadeDuration={0}
          style={myStyles.tabImageStyle}
          source={selected ? categoryObject.imageSelected : categoryObject.imageUnselected}
        />
      </View>
      <Text style={myStyles.tabLabelStyle}>
        {categoryObject.title}
      </Text>
    </TouchableOpacity>
  );
};

export default SideMenuItem;
